export default __webpack_public_path__ + "static/media/5Loop.16a3ee07.mp4";